import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Button, Chip, Table, TableBody, TableCell, TableContainer, TableRow } from "@mui/material";
import MainCard from "components/MainCard";
import { getEquipmentsCategoriesById } from "components/axios/equipmentAlertsAxios";
import ComponentStatusDiv from "../ComponentStatusDiv";
import { useEnumApi } from "contexts/EnumApiContext";
import { equipmentFaultStatusColors, getDiagnosisGradeColor } from "data/data";
import EquipmentPartListMonitoringSuspend from "../EquipmentPartListMonitoringSuspend";
import EquipmentRemarkModifyLayer from "components/layer/EquipmentRemarkModifyLayer";
import { Link } from "react-router-dom";

const EquipmentStatusCard = ({info, station, setIsLoading}) => {
    const { getEnumValueByEnumNameAndCode } = useEnumApi();
    const { t } = useTranslation();

    const [equipmentComponents, setEquipmentComponents] = useState([]);
    const [componentId, setComponentId] = useState(null);
    // const [grade, setGrade] = useState();

    useEffect(()=>{
        if (info) {
            Promise.all([
                // 설비 등급
                // getDiagnosisExecutionsEquipmentsLowestGradeById(info.id).then((data)=>{
                //     setGrade(data);
                // }),
                // 구성부목록
                getEquipmentsCategoriesById(info.id).then((data)=>{
                    if (data && data.length>0) {
                        // console.log(data)
                        setEquipmentComponents(data);
                        // const result = data.find(item=>item.sensorYn)
                        const result = data[0]
                        if (result)
                            equipmentPartsByComponentId(result.id);
                        return data;
                    // } else if (info?.equipmentCtgr?.parent?.parent?.code === 'EV' || info?.equipmentCtgr?.parent?.parent?.code === 'ES') {
                    } else if (info?.latestEquipmentOp) {
                        equipmentPartsByComponentId(-1);
                    }
                    setEquipmentComponents(null);
                    return null;
                })
            ]);
        }
    },[info]);
    
    // 해당 구성부에 해당하는 자재목록
    const equipmentPartsByComponentId = (compId) => {
        setComponentId(compId);
    }  

    return (
        <>
            <div className='alert_phrase'>
                {info && 
                <MainCard className="center_table" content={false}>
                    <div className="statuscard_tit" style={{display:"flex", justifyContent:"space-between", backgroundColor:"#353535"}}>
                        <div style={{marginBottom:"10px"}}>
                            <span className='bullet'><img src={`${process.env.PUBLIC_URL}/img/icon/subway1.png`} alt='' /></span>&nbsp;
                            <Chip label={t('message.common.chip.equipment.status.status')} color="success" />
                        </div>

                        <Link to={`/equipment/${info?.id}`}><Button variant="contained">{t('message.common.btn.equipment.status.view')}</Button></Link>
                    </div>
                    <TableContainer>
                        <Table sx={{ minWidth: 400 }} aria-label="simple table" className="same_width">
                            <TableBody>
                                <TableRow>
                                    <TableCell className="th" align="center">{t('message.common.subtitle.equipment.level2')}</TableCell>
                                    <TableCell align="center">{info && info.equipmentCtgr.parent.name}</TableCell>
                                    <TableCell className="th" align="center">{t('message.common.subtitle.equipment.level3')}</TableCell>
                                    <TableCell align="center">{info && info.equipmentCtgr.name}</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell className="th" align="center">{t('message.common.subtitle.equipment.number')}</TableCell>
                                    <TableCell align="center">{info && info.equipmentNo}</TableCell>
                                    <TableCell className="th" align="center">{t('message.common.subtitle.equipment.name')}</TableCell>
                                    <TableCell align="center">{info && info.name}</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell className="th" align="center">{t('message.common.subtitle.mfCpnyNm')}</TableCell>
                                    <TableCell align="center" colSpan={3}>{info && info.mfCpnyNm}</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell className="th" align="center">{t('message.common.subtitle.madeYmd')}</TableCell>
                                    <TableCell align="center">{info && info.madeYmd}</TableCell>
                                    <TableCell className="th" align="center">{t('message.common.subtitle.position')}</TableCell>
                                    <TableCell align="center">{info && info.location}</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell className="th" align="center">{t('message.common.subtitle.grade')}</TableCell>
                                    <TableCell align="center">{info?.lowestDiagnosisRank || '-'}</TableCell>
                                    <TableCell className="th" align="center">{t('message.common.subtitle.manager')}</TableCell>
                                    <TableCell align="center">{station?.mngrNm || '-'}</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell className="th" align="center">{t('message.common.subtitle.remark')}</TableCell>
                                    <TableCell align="center" colSpan={3}>
                                        <div  style={{display:"flex"}}>
                                        <div style={{whiteSpace:"pre-line", textAlign:"left", width:"100%"}}>
                                            {info && info.remark}
                                        </div>
                                        <EquipmentRemarkModifyLayer equipmentId={info.id} setIsLoading={setIsLoading} />
                                        </div>
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell className="th" align="center">{t('message.common.subtitle.manager')}</TableCell>
                                    <TableCell colSpan="3" align="center">{(station && station.mngrNm) || '-'}</TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </TableContainer>
                </MainCard>
                }

                <MainCard className="center_table" content={false}>
                    <TableContainer>
                        <Table sx={{ minWidth: 500 }} aria-label="simple table">
                            <TableBody>
                                <TableRow>
                                    <TableCell style={{textAlign:"left"}}>
                                        <ComponentStatusDiv equipment={info} equipmentComponents={equipmentComponents} componentId={componentId} equipmentPartsByComponentId={equipmentPartsByComponentId} />
                                    </TableCell>
                                    <TableCell align="center" style={{width:"200px", fontSize:"25px"}}>
                                        {/* <span className={getDiagnosisGradeColor(grade)}>{t('message.common.subtitle.defect')} : {grade || '-'}</span> */}
                                        <span className={equipmentFaultStatusColors.find(data => data.code === info?.status)?.color}>{t('message.common.subtitle.defect')} : {getEnumValueByEnumNameAndCode('EquipmentFaultStatus',info?.status)[0]?.title || '-'}</span>
                                    </TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </TableContainer>
                </MainCard>

                {componentId && <EquipmentPartListMonitoringSuspend equipment={info} componentId={componentId} />}
            </div>
        </>
    )
}

export default EquipmentStatusCard;